import { createSlice, PayloadAction } from '@reduxjs/toolkit';

type ComponentAsyncRequestData =
  | { readonly type: 'updateFeatures'; readonly requestGuid: string }
  | { readonly type: 'analyze'; readonly requestGuid: string }
  | { readonly type: 'loadComponentDesign'; readonly requestGuid: string };

interface AsyncRequestsData {
  readonly [componentDesignGuid: string]: ComponentAsyncRequestData | undefined;
}

const initialState: AsyncRequestsData = {};

const asyncRequestsSlice = createSlice({
  name: 'asyncRequests',
  initialState,
  reducers: {
    onInitiatingLoadComponentDesignRequest: (
      state,
      action: PayloadAction<{ componentDesignGuid: string; requestGuid: string }>,
    ) => {
      const { componentDesignGuid, requestGuid } = action.payload;
      const oldRequest = state[componentDesignGuid];
      console.assert(!oldRequest || oldRequest.type === 'loadComponentDesign');
      state[componentDesignGuid] = { type: 'loadComponentDesign', requestGuid };
    },
    onInitiatingAnalyzeRequest: (
      state,
      action: PayloadAction<{ componentDesignGuid: string; requestGuid: string }>,
    ) => {
      const { componentDesignGuid, requestGuid } = action.payload;
      const oldRequest = state[componentDesignGuid];
      console.assert(!oldRequest || oldRequest.type === 'analyze');
      state[componentDesignGuid] = { type: 'analyze', requestGuid };
    },
    onInitiatingUpdateFeaturesRequest: (
      state,
      action: PayloadAction<{ componentDesignGuid: string; requestGuid: string }>,
    ) => {
      const { componentDesignGuid, requestGuid } = action.payload;
      const oldRequest = state[componentDesignGuid];
      console.assert(!oldRequest || oldRequest.type === 'updateFeatures');
      state[componentDesignGuid] = { type: 'updateFeatures', requestGuid };
    },
    onCompletingAsyncRequest: (state, action: PayloadAction<{ componentDesignGuid: string; requestGuid: string }>) => {
      const componentRequest = state[action.payload.componentDesignGuid];
      if (componentRequest && componentRequest.requestGuid === action.payload.requestGuid) {
        delete state[action.payload.componentDesignGuid];
      }
    },
  },
});

export const {
  onInitiatingLoadComponentDesignRequest,
  onInitiatingAnalyzeRequest,
  onInitiatingUpdateFeaturesRequest,
  onCompletingAsyncRequest,
} = asyncRequestsSlice.actions;
export const asyncRequests = asyncRequestsSlice.reducer;
